import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsQuery from "./InsightsQuery";
import type QuerySnippet from "./QuerySnippet";
import type QuerySnippetGroup from "./QuerySnippetGroup";
import type Stream from "./Stream";

@Model()
class QuerySnippetLink extends ApplicationRecord {
  static jsonapiType = "query_snippet_links";

  @BelongsTo() group: QuerySnippetGroup;

  @BelongsTo() object: Stream | InsightsQuery;

  @Attr() objectId: number;

  @Attr() objectType: string;

  @HasOne() querySnippet: QuerySnippet;

  @Attr() querySnippetId: number;
}

export default QuerySnippetLink;
